import request from "../utils/request"
import { hostUrl } from "../utils/constant"

// 获取用户频道信息
export const userLogOut = function() {
  return request.get(`main/plat/v1/access/logout`);
};

// 获取用户频道信息
export const getUserInfo = function() {
  return request.get(`main/plat/v2/access/getinfo`);
};

export const isLogin = () => {
  return new Promise((resolve) => {
    window.QHPass.getUserInfo(
      false,
      () => {
        resolve(true);
      },
      () => {
        resolve(false);
      }
    );
  });
};

